import React from 'react';
import PropTypes from 'prop-types';
import MessageNote from './components/MessageNote';
import RegularNote from './components/RegularNote';
import { INTERACTION_TYPES } from './constants';
import './Note.scss';

const Note = (props) => (
  props.noteType === INTERACTION_TYPES.MESSAGE ? (
    <MessageNote {...props} />
  ) : (
    <RegularNote {...props} />
  )
);

Note.defaultProps = {
  currentEmployeeId: '',
  duration: null,
  noteType: 'Note',
  note: {},
  details: {},
  reason: '',
  showDeleteNoteIcon: false,
  showEditNoteIcon: false,
  isEditing: false,
  onEdit: null,
  onCancelEdit: null,
  person: {},
  sender: {},
  visibility: '',
  renderTextAsHtml: false,
};

Note.propTypes = {
  currentEmployeeId: PropTypes.string,
  interactionDate: PropTypes.object.isRequired,
  interactionType: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  duration: PropTypes.string,
  category: PropTypes.string.isRequired,
  details: PropTypes.object,
  reason: PropTypes.string,
  note: PropTypes.object,
  noteType: PropTypes.string,
  visibility: PropTypes.string,
  showDeleteNoteIcon: PropTypes.bool,
  showEditNoteIcon: PropTypes.bool,
  isEditing: PropTypes.bool,
  onEdit: PropTypes.func,
  onCancelEdit: PropTypes.func,
  person: PropTypes.object,
  sender: PropTypes.object,
  renderTextAsHtml: PropTypes.bool,
};

export default Note;
